import {
  accountLoginCreate,
  accountSignupCreate,
  accountVerifyCreate,
  getCsrfToken,
  logoutUser,
  accountValidateSessionList,
  type LoginRequest,
  type SignupRequest,
  type UserLoginResponse,
  type UserSignupResponse,
  type VerifyEmailResponse,
  type ValidateSessionResponse,
  type accountLoginCreateResponse,
  type accountSignupCreateResponse,
  type accountVerifyCreateResponse,
  type accountValidateSessionListResponse
} from './types/api.generated';
import {
  accountVerifyCreateResponse as accountVerifyCreateResponseSchema,
  accountLoginCreateResponse as accountLoginCreateResponseSchema
} from './types/schemas.zod';
import { apiClient } from './ApiService';

const login = async (email: string, password: string): Promise<UserLoginResponse | undefined> => {
  const loginData: LoginRequest = { email, password };
  const response: accountLoginCreateResponse = await accountLoginCreate(loginData);
  const validatedResponse = accountLoginCreateResponseSchema.parse(response.data);
  if (response.status === 200) {
    return validatedResponse;
  }
};

const signup = async (body: SignupRequest): Promise<UserSignupResponse | undefined> => {
  const response: accountSignupCreateResponse = await accountSignupCreate(body);
  if (response.status === 201) {
    return response.data;
  }
};

const verifyEmail = async (token: string): Promise<VerifyEmailResponse | undefined> => {
  const response: accountVerifyCreateResponse = await accountVerifyCreate(token);
  const validatedResponse = accountVerifyCreateResponseSchema.parse(response.data);
  if (response.status === 200) {
    return validatedResponse;
  }
};

const fetchCSRFToken = async (): Promise<void> => {
  await getCsrfToken();
};

const logout = async (): Promise<void> => {
  try {
    await apiClient.post('/auth/logout', {}, {}, true);
  } catch {
    // ignore
  }

  try {
    await logoutUser();
  } catch {
    // ignore
  }
};

const validateSession = async (): Promise<ValidateSessionResponse | undefined> => {
  const response: accountValidateSessionListResponse = await accountValidateSessionList();
  if (response.status === 200) {
    return response.data;
  }
};

const createSessionFromClerkCookie = async (): Promise<void> => {
  await apiClient.post('/auth/session', {}, {}, true);
};

export const SessionService = {
  login,
  signup,
  verifyEmail,
  fetchCSRFToken,
  logout,
  validateSession,
  createSessionFromClerkCookie
};
